export default "__VITE_ASSET__d33f9bfd__"